/**
 * Text Field Default Configuration
 *
 * Basic text input field with label and exclusion support.
 * Properties aligned with API JSON configuration structure.
 */

export interface TextFieldConfig {
  label: string;
  style: 'text' | 'label';
  showTitle: boolean;
  exclusionType: 'hide' | 'disable';
  displayName: string;
  shortDisplayName?: string;
  required: boolean;
  value: string;
}

export const TEXT_DEFAULT_CONFIG: Omit<TextFieldConfig, 'label' | 'displayName'> = {
  style: 'text',
  showTitle: true,
  exclusionType: 'hide',
  shortDisplayName: '',
  required: false,
  value: '',
};

/**
 * Create default configuration for a text field
 * @param fieldName The field name to use as label
 */
export const createTextConfig = (fieldName: string): TextFieldConfig => ({
  ...TEXT_DEFAULT_CONFIG,
  label: fieldName,
  displayName: '',
});

export default createTextConfig;
